<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'assuntosCrud'"
          crudName="Assuntos"
          newText="Novo Assunto"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="true"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "assuntosTable",
      columns: ["id", "nome", "total_documentos", "actions"],
      tableData: ["id", "nome", "total_documentos"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "nome"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 15,
        perPageValues: [15, 25, 50, 100],
        headings: {
          id: "ID",
          nome: "Assunto",
          total_documentos: "Qtd.",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {},
        requestFunction: function (data) {
          let requestData = {};
          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios
            .get(this.url + "?" + query, requestData)
            .catch(function (e) {
              this.dispatch("error", e);
            }.bind(this));
        },
      },
      endPoint: "assuntos",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = { id: "id", nome: "nome" };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>
